import { FunctionComponent, useCallback } from "react";
import { PencilIcon } from "@icons/PencilIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { IconButton } from "@ui-kit/IconButton/IconButton";
import { useTranslation } from "react-i18next";
import { SharePlan } from "../SharePlan/SharePlan";
import { useNavigate } from "@hooks/useNavigate/useNavigate";

import "./PlanActionBar.css";

const PlanActionBar: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEditPlan = useCallback(() => {
    navigate("/plan?planView=edit");
  }, [navigate]);

  return (
    <div className="plan-action-bar-component">
      <IconButton
        onPress={handleEditPlan}
        label={t("common.edit")}
        icon={<PencilIcon size={18} color={colors.neutral700} />}
      />
      <SharePlan />
    </div>
  );
};

export { PlanActionBar };
